import { defineComponent as _defineComponent } from 'vue'
import loadingImage from '@/assets/images/explore/loading-image.svg'

export default /*@__PURE__*/_defineComponent({
  __name: 'SplashScreen',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get loadingImage() { return loadingImage } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})